import React from 'react';
import { useSelector } from 'react-redux';
import { getQuote } from '../../../features/quote/QuoteSlice';
import { DataEvents, DataCategories, DataActions } from '../../../types/enum';
import Utils from '../../helpers/Utils';

function Header() {
  const quoteData = useSelector(getQuote);
  const { innerStep, step: outerStep } = quoteData.step;

  return (
    <header className="header v2-header p-3">
      <div className="container">
        <div className="d-flex flex-wrap justify-content-between">
          <div className="v2-header__inner d-flex mx-4 flex-wrap">
            <a href="https://www.kingsbridge.co.uk" className="align-self-center">
              <img alt="logo" src="/images/dark-logo-rebranded.svg" />
            </a>
            <div className="vertical-divider vertical-divider--32" />
            <div className="v2-header__lower-block">
              <img alt="feefo ratings" className="v2-header__feefo align-self-center" src="/images/feefo.png" />
              <a
                href="tel:+441242808740"
                className="v2-header__cta btn btn-outline-dark btn-tel align-self-center py-3 px-4"
                onClick={() => Utils.sendDataLayerEvent({
                  event:
                    DataEvents[DataEvents.analyticsEvent],
                  eventCategory:
                    DataCategories[DataCategories['Quote Journey']],
                  eventAction:
                    DataActions[DataActions['Click to call']],
                  stepNumber: outerStep + 1,
                  stepName: quoteData.steps[(outerStep)].steps[innerStep].title,
                })}
              >
                Call us on: 01242 808740
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
